// General
import "./gifts.scss";
import { useLocation } from "react-router-dom";
// Services
import { usePostPrivateCallRoomGiftRequestMutation } from "../../../../services/data.service";
// Redux
import { useSelector, useDispatch } from "react-redux";
import { updateSelectedGift } from "../../../../redux/store/livestreamingStore";
// react-gtm-module
import TagManager from "react-gtm-module";
// Material UI
import { ButtonBase } from "@mui/material";
// i18next
import { useTranslation } from "react-i18next";
// Material UI
import { Badge } from "@mui/material";
// Custom Hooks
import IconManager from "../../../utility/manager/icon-manager/icon-manager";

const Gifts = (props) => {
  const { state, productHashId, giftImage, giftAmount, isEventBased } = props;

  // API variables
  const [
    requestGift,
    {
      data: requestGiftData,
      error: requestGiftErrorData,
      isLoading: requestGiftLoading,
      isSuccess: requestGiftSuccess,
      isError: requestGiftError,
    },
  ] = usePostPrivateCallRoomGiftRequestMutation();

  // Redux variables
  const selectedGift = useSelector((state) => state.livestreaming.selectedGift);
  const requestId = useSelector((state) => state.privateCall.requestId);
  const isDaddy = useSelector((state) => state.user.isDaddy);
  const giftReceived = useSelector((state) => state.privateCall.giftReceived);
  const dispatch = useDispatch();

  // Router variables
  const location = useLocation();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getIcon = IconManager();

  // Event Handlers | Button
  const onSelectGift = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: "PWA-S2-2.3-Button",
      },
    });

    dispatch(updateSelectedGift(productHashId));

    if (location.pathname.includes("video-call")) {
      if (!isDaddy) {
        const obj = {
          call_request_id: requestId,
          message: `${t("1on1.gift_request_1")} :gift`,
          product_hash_id: productHashId,
        };

        requestGift(obj);
      }
    }
  };

  // Utility Functions
  const getGiftBadgeCount = (productHashId) => {
    if (state === "private-call" && !isDaddy) {
      return (
        giftReceived?.filter((gift) => gift === productHashId)?.length || 0
      );
    } else {
      return 0;
    }
  };

  return (
    <ButtonBase
      id="gifts-tab-gifts-subcomponent"
      className={`${selectedGift === productHashId && "selected-gift"}`}
      component="div"
      onClick={onSelectGift}
    >
      <Badge
        className="gift-badge-container"
        badgeContent={getGiftBadgeCount(productHashId)}
        color="primary"
      >
        <div className="gifts-image-container">
          <img
            className={`${
              state === "livestream" || isDaddy
                ? "gifts-image"
                : "grey-gifts-image"
            } ${
              state === "private-call" && getGiftBadgeCount(productHashId) > 0
                ? "ungrey-gifts-image"
                : ""
            }`}
            src={giftImage}
            alt="gift"
          />

          {isEventBased && (
            <div className="gift-event-container">
              <div className="event-label">{t("live.gifts_event")}</div>
            </div>
          )}
        </div>
      </Badge>

      <div className="amount-container">
        <div className="coin-icon-container">
          {getIcon("sbCoinIcon", "coin-icon")}
        </div>
        <div className="amount">{giftAmount}</div>
      </div>
    </ButtonBase>
  );
};

export default Gifts;
